import { faEllipsisV, faPen, faWarehouse } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Dropdown, List, Tag, Tooltip } from "antd";
import EmptyWarehouseLayoutState from "../EmptyWarehouseLayoutsState/EmptyWarehouseLayoutState";
import "./WarehouseLayoutsListPanel.css";
import MoreActionsMenu from "../WarehousesList/MoreActionsMenu";

const formatMonthDateYear12Hr = (dateStr) => {
  const date = new Date(dateStr);

  const month = String(date.getMonth() + 1).padStart(2, "0"); // month is 0-based
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // 0 => 12

  return `${month}-${day}-${year} ${hours}:${minutes} ${ampm}`;
};

function WarehouseLayoutsListPanel({
  loading,
  warehouses,
  onDialogHandler,
  loadDemoLayout,
  isDemoLayoutImporting,
  onNavigateToLayoutEditor,
  onNavigateToInventory,
  onNavigateToDataView,
  onEditLayout,
  onActivate,
  onDelete,
}) {
  if (loading) {
    return (
      <List
        style={{ flex: 1, overflowY: "auto", overflowX: "hidden" }}
        itemLayout="horizontal"
        dataSource={[]} // Show only loading spinner
        loading={true}
      />
    );
  }

  if (warehouses.length === 0) {
    return (
      <div className="empty-layout-container">
        <EmptyWarehouseLayoutState createLayoutHandler={onDialogHandler} loadDemoLayoutHandler={loadDemoLayout} isDemoLayoutImporting={isDemoLayoutImporting} />
      </div>
    );
  }

  return (
    <List
      style={{ flex: 1, overflowY: "auto", overflowX: "hidden" }}
      itemLayout="horizontal"
      dataSource={warehouses}
      loading={false}
      renderItem={(item, index) => (
        <List.Item
          key={item.id}
          className="warehouse-item"
          actions={[
            <Button key="configure" className="configure" onClick={() => onNavigateToLayoutEditor(item)}>
              Configure
            </Button>,
            <Button key="inventory" onClick={() => onNavigateToInventory(item)}>
              Inventory
            </Button>,
            <Button key="dataview" onClick={() => onNavigateToDataView(item)}>
              Dataview
            </Button>,
            <Dropdown overlay={MoreActionsMenu(item, { onActivate, onDelete })} trigger={["click"]} key="more-actions">
              <Button>
                <FontAwesomeIcon icon={faEllipsisV} />
              </Button>
            </Dropdown>,
          ]}
        >
          <List.Item.Meta
            avatar={
              <div className="warehouse-icon">
                <FontAwesomeIcon icon={faWarehouse} />
              </div>
            }
            title={
              <div className="warehouse-info">
                <div className="warehouse-name">
                  {item.name}
                  {/* Edit layout */}
                  <button className="edit-btn" onClick={() => onEditLayout(item)}>
                    <Tooltip title="Edit layout">
                      <FontAwesomeIcon icon={faPen} />
                    </Tooltip>
                  </button>

                  {item.isActive ? <Tag color="green">Active</Tag> : null}
                </div>
                <div className="warehouse-details">
                  <span>Last updated {formatMonthDateYear12Hr(item.updatedAt) || "N/A"}</span>
                </div>
              </div>
            }
          />
        </List.Item>
      )}
    />
  );
}

export default WarehouseLayoutsListPanel;
